import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaBroom} from "react-icons/fa";

function CommercialCleaningServices() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

   const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We were getting cleanliness complaints almost every week. After Helper Ji’s commercial cleaning team started, the situation improved gradually. Now the office stays clean most of the day.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Helper Ji cleaning staff doesn’t rush the work. Floors, desks, and washrooms are cleaned properly, which we didn’t get from earlier vendors.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "We started with basic cleaning from Helper Ji, and later added more areas because the service quality stayed consistent.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

const services = [
    {
      name: "Commercial Cleaning Services Noida",
      link: "/commercial-cleaning-services-noida",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Gurugram",
      link: "/commercial-cleaning-services-gurugram",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Delhi",
      link: "/commercial-cleaning-services-delhi",
      icon: <FaBroom />
    }
  ];


  return (
    <Fragment>
      <Helmet>
        
           {/* BASIC META */}
    <title>Commercial Cleaning Services in Ghaziabad | Best Office Cleaning Solutions</title>
    <meta
      name="description"
      content="Hire professional commercial cleaning services in Ghaziabad offering office deep cleaning services, corporate cleaning solutions from a trusted commercial cleaning company."
    />
    <meta
      name="keywords"
      content="Commercial Cleaning Services In Ghaziabad, Best Office Cleaning Services In Ghaziabad, Professional Cleaning Services In Ghaziabad, Office Deep Cleaning Services In Ghaziabad, Commercial Cleaning Services Company In Ghaziabad, Professional Commercial Cleaning Services In Ghaziabad"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/commercial-cleaning-services-ghaziabad"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Commercial Cleaning Services in Ghaziabad | Best Office Cleaning Solutions"
    />
    <meta
      property="og:description"
      content="Hire professional commercial cleaning services in Ghaziabad offering office deep cleaning services, corporate cleaning solutions from a trusted commercial cleaning company."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/commercial-cleaning-services-ghaziabad"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Commercial Cleaning Services in Ghaziabad | Best Office Cleaning Solutions"
    />
    <meta
      name="twitter:description"
      content="Hire professional commercial cleaning services in Ghaziabad offering office deep cleaning services, corporate cleaning solutions from a trusted commercial cleaning company."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/commercial-cleaning-services-ghaziabad",
        "name": "Commercial Cleaning Services in Ghaziabad | Best Office Cleaning Solutions",
        "description": "Hire professional commercial cleaning services in Ghaziabad offering office deep cleaning services, corporate cleaning solutions from a trusted commercial cleaning company."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Commercial Cleaning Services in Ghaziabad",
        "image": "https://www.helperji.in/assets/img/officeclean.jpg",
        "description": "Hire professional commercial cleaning services in Ghaziabad offering office deep cleaning services, corporate cleaning solutions from a trusted commercial cleaning company.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "448"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Commercial Cleaning Services",
            "item": "https://www.helperji.in/commercial-cleaning-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Commercial Cleaning Services in Ghaziabad",
            "item": "https://www.helperji.in/commercial-cleaning-services-ghaziabad"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Why choose professional cleaning services in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Hiring professional cleaning services in Ghaziabad ensures better hygiene, consistent cleanliness, and a healthier office environment."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer office deep cleaning services in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide office deep cleaning services in Ghaziabad for offices that need detailed and thorough cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "What areas are covered under your office cleaning services in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our services include floors, desks, equipment, glass cabins, conference rooms, and pantry areas as part of commercial office cleaning services."
            }
          },
          {
            "@type": "Question",
            "name": "Is Helper Ji known for the best office cleaning services in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji is trusted for delivering the best office cleaning services in Ghaziabad with consistent quality."
            }
          },
          {
            "@type": "Question",
            "name": "Are your commercial office cleaning services affordable in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, our commercial office cleaning services are priced reasonably while maintaining high cleaning standards."
            }
          }
        ]
      }
      `}
    </script>
     <script type="text/javascript">
          {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
        </script>

      </Helmet>
      <Floatingcall />
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">
          <div className="section-header">
            <h2>COMMERCIAL CLEANING SERVICES IN GHAZIABAD</h2>
            <p>
              Reliable Office & Workplace Cleaning in Ghaziabad
            </p>
          </div>

          <div className="row gy-4">
            <div class="col-lg-6">
              <img
                src="/assets/img/officeclean.jpg"
                className="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>

            <div className="col-lg-6">
              <div className="content ps-0 ps-lg-5">
                <p className="text-justify">
                 Helper Ji offers dependable Professional Cleaning Services in Ghaziabad for offices seeking cleanliness without high maintenance costs. Our services are ideal for offices, business centres, and commercial workplaces that value hygiene and organisation.
                </p>
                <p className="text-justify">
                  We are known for providing the Best Office Cleaning Services in Ghaziabad with trained staff, systematic procedures, and quality-controlled cleaning. Our focus remains on hygiene, safety, and consistent cleaning standards to maintain a professional workplace.
                </p>
             <p className="text-justify">Our commercial office cleaning services in Ghaziabad are tailored to meet the needs of offices of all sizes. Whether you need regular cleaning, deep cleaning, or scheduled maintenance, our team ensures workspaces remain clean, organised, and comfortable without interrupting daily operations.</p>
                <div class="text-left">
                  <Link
                    to="/contact-us"
                    className="booknow"
                    onClick={scrollToTop}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services sections-bg">
        <div className="container" data-aos="fade-up">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="content ps-0 ps-lg-5">
                <h3>Why Helper Ji is Preferred in Ghaziabad</h3>
                <p>Businesses trust Helper Ji for commercial office cleaning services because we provide:</p>
                   <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> A reliable team experienced in professional office cleaning.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> Affordable and transparent pricing.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> Compliance with safety and hygiene standards.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> Consistent cleaning quality.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> Timely and professional service.
                  </li>
                </ul>
                <p className="pt-4">
                  Our Professional Cleaning Services in Ghaziabad are available across major commercial areas, supporting offices of all sizes.
                </p>
                <p>Maintain a clean and organised workplace with Helper Ji. Book office deep cleaning services in Ghaziabad today and experience professional cleaning tailored to your business needs.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src="/assets/img/officecleaning.jpg"
                className="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>


      <section id="services" className="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
           FAQs – COMMERCIAL CLEANING SERVICES IN GHAZIABAD
          </h3>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Why choose professional cleaning services in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Hiring Professional Cleaning Services in Ghaziabad ensures better hygiene, consistent cleanliness, and a healthier office environment.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                 Do you offer office deep cleaning services in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, we provide Office Deep Cleaning Services in Ghaziabad for offices that need detailed and thorough cleaning.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  What areas are covered under your office cleaning services in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our services include floors, desks, equipment, glass cabins, conference rooms, and pantry areas as part of commercial office cleaning services.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Is Helper Ji known for the best office cleaning services in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we are trusted for delivering the Best office cleaning services in Ghaziabad with consistent quality.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Are your commercial office cleaning services affordable in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, our commercial office cleaning services are priced reasonably while maintaining high cleaning standards.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient />

 <section className="py-5 sections-bg">
      <div className="container">
        <div className="row mb-4">
          <div className="col text-center">
            <h2 className="fw-bold">Other Locations</h2>
            <p className="text-muted">
              Explore our other locations of Commercial Cleaning Services
            </p>
          </div>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-md-4 col-sm-6" key={index}>
              <Link
                to={service.link}
                className="text-decoration-none text-dark"
              >
                <div className="card h-100 shadow-sm border-0 service-card">
                  <div className="card-body d-flex align-items-center">
                    <div className="service-icon me-3">
                      {service.icon}
                    </div>
                    <h6 className="mb-0 fw-semibold">
                      {service.name}
                    </h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>

    </Fragment>
  );
}

export default CommercialCleaningServices;
